import BaseApiService from './BaseApiService';

class CategoryApiService extends BaseApiService {
    constructor() {
        super('categories');
    }

    async getAll() {
        const response = await this.request({ method: 'get', url: '' });
        return response && response.categories ? response.categories : [];
    }
}

export default new CategoryApiService();
